import { SideNavInterface } from "../../interfaces/side-nav.type";

export const ADMIN_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Công ty",
    iconType: "",
    iconTheme: "outline",
    icon: "home",
    submenu: [
      {
        path: "/users/issuer/list",
        title: "Danh sách",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
      {
        path: "/products/fund/list",
        title: "Quỹ liên kết",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
    ],
    src: "../../../assets/images/icons/ic-company.svg",
  },

  {
    path: "/products/list",
    title: "Sản phẩm",
    iconType: "",
    iconTheme: "outline",
    icon: "fund",
    submenu: [],
    src: "../../../assets/images/icons/ic-product.svg",
  },

  {
    path: "/products/filter-by-question",
    title: "Bộ lọc sản phẩm",
    iconType: "",
    iconTheme: "outline",
    icon: "filter",
    submenu: [],
    src: "../../../assets/images/icons/ic-filter.svg",
  },
  {
    path: "/users/customer/list",
    title: "Khách hàng",
    iconType: "",
    iconTheme: "outline",
    icon: "team",
    submenu: [
      // {
      //   path: '/users/investor',
      //   title: 'Nhà đầu tư',
      //   iconType: 'nzIcon',
      //   iconTheme: 'outline',
      //   icon: 'user',
      //   submenu: [],src: ''
      // },
      // {
      //   path: '/users/normal/issuer',
      //   title: 'Tổ chức phát hành',
      //   iconType: 'nzIcon',
      //   iconTheme: 'outline',
      //   icon: 'team',
      //   submenu: [],src: ''
      // },
    ],
    src: "../../../assets/images/icons/ic-user.svg",
  },

  {
    path: "",
    title: "Tài khoản",
    iconType: "",
    iconTheme: "outline",
    icon: "user",
    src: "../../../assets/images/icons/ic-account.svg",
    submenu: [
      {
        path: "/users/admin/list",
        title: "Admin",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
    ],
  },
  // {
  //   path: "/documents/survey/list",
  //   title: "Phiếu khảo sát",
  //   iconType: "",
  //   iconTheme: "outline",
  //   icon: "dollar",
  //   submenu: [],
  //   src: "../../../assets/images/icons/ic-document.svg",
  // },
  // {
  //   path: "/documents/contract/list",
  //   title: "Hợp đồng",
  //   iconType: "",
  //   iconTheme: "outline",
  //   icon: "dollar",
  //   submenu: [],
  //   src: "../../../assets/images/icons/ic-contract.svg",
  // },
  {
    path: "",
    title: "CMS",
    iconType: "",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/cms/question/list",
        title: "Câu hỏi",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
      {
        path: "/cms/knowledge/list",
        title: "Kiến thức",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
    ],
    src: "../../../assets/images/icons/ic-cms.svg",
  },
  {
    path: "",
    title: "Dữ liệu",
    iconType: "",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/master-data/benefit-type/list",
        title: "Loại quyền lợi",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
      {
        path: "/master-data/benefit-detail/list",
        title: "Quyền lợi chi tiết",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
    ],
    src: "../../../assets/images/icons/ic-data.svg",
  },
];
export const EMPLOYEE_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Công ty",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "home",
    submenu: [
      {
        path: "/users/issuer/list",
        title: "Danh sách",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
      {
        path: "/products/fund/list",
        title: "Quỹ liên kết",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
    ],
    src: "",
  },

  {
    path: "/products/list",
    title: "Sản phẩm",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "fund",
    submenu: [],
    src: "",
  },
  {
    path: "/users/customer/list",
    title: "Khách hàng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "team",
    submenu: [],
    src: "",
  },
  {
    path: "/documents/survey/list",
    title: "Phiếu khảo sát",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [],
    src: "",
  },
  {
    path: "/documents/contract/list",
    title: "Hợp đồng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [],
    src: "",
  },
  {
    path: "",
    title: "CMS",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/cms/question/list",
        title: "Câu hỏi",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
      {
        path: "/cms/knowledge/list",
        title: "Kiến thức",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
    ],
    src: "",
  },
];
export const MARKETING_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Công ty",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "home",
    submenu: [
      {
        path: "/users/issuer/list",
        title: "Danh sách",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
      {
        path: "/products/fund/list",
        title: "Quỹ liên kết",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
        src: "",
      },
    ],
    src: "",
  },

  {
    path: "/products/list",
    title: "Sản phẩm",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "fund",
    submenu: [],
    src: "",
  },

  {
    path: "",
    title: "CMS",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [
      {
        path: "/cms/question/list",
        title: "Câu hỏi",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
      {
        path: "/cms/knowledge/list",
        title: "Kiến thức",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "read",
        submenu: [],
        src: "",
      },
    ],
    src: "",
  },
];
